import { useRef } from 'react';

/**
 * Returns true when the serialised form value diverges from what it was when
 * the modal last transitioned from hidden → visible (show: false → true).
 *
 * Baseline is captured synchronously on the first render where show=true,
 * so there is no flash of isDirty=true on modal open.
 */
export function useUnsavedChanges<T>(show: boolean, currentValue: T): boolean {
  const baselineRef = useRef<string>('');
  const wasShownRef = useRef(false);

  if (show && !wasShownRef.current) {
    wasShownRef.current = true;
    baselineRef.current = JSON.stringify(currentValue);
  }

  if (!show) {
    wasShownRef.current = false;
    return false;
  }

  return baselineRef.current !== JSON.stringify(currentValue);
}
